'use client';

import { c as _c } from "react/compiler-runtime";
import { LinkList } from '@petsmart-ui/sparky';
import { useMemo } from 'react';
import { SidebarItem } from '@/components/Menu/SidebarItem';
import { SIDEBAR_MENU_ITEMS } from '@/constants';
import { useUserData } from '@/hooks';
import type { MenuProps } from '@/types';
import { getVisibleMenuItems } from '@/utils/navigationAccess';
import './menu.scss';
const componentClassName = 'merchant-menu';
export default function Menu(t0) {
  const $ = _c(9);
  const {
    handleClose
  } = t0;
  const {
    groups,
    isLoading
  } = useUserData();
  let t1;
  if ($[0] !== groups) {
    t1 = getVisibleMenuItems(SIDEBAR_MENU_ITEMS, groups);
    $[0] = groups;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const filteredMenuItems = t1;
  let t2;
  if ($[2] !== filteredMenuItems || $[3] !== handleClose) {
    let t3;
    if ($[5] !== handleClose) {
      t3 = item => <SidebarItem key={item.title} item={item} handleClose={handleClose} />;
      $[5] = handleClose;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = filteredMenuItems.map(t3);
    $[2] = filteredMenuItems;
    $[3] = handleClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const menuItems = t2;
  if (isLoading) {
    return null;
  }
  let t3;
  if ($[7] !== menuItems) {
    t3 = <aside className={componentClassName}><nav><LinkList>{menuItems}</LinkList></nav></aside>;
    $[7] = menuItems;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}